module.exports = __webpack_public_path__ + "img/favicon.7043396.png";